<template>
  <GeneralMessageNotice type="default" :message="noticeMessage" />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import GeneralMessageNotice from '@/components/domains/chat/chat-general/GeneralMessageNotice.vue';
import { ChatMessage } from '@/types/socket';

const props = withDefaults(
  defineProps<{
    message: ChatMessage;
  }>(),
  {
    message: () => ({}) as ChatMessage,
  }
);

const { t } = useI18n();

const noticeMessage = computed<string>(() => {
  return (
    {
      in: t('entered_someone_end', { nickname: props.message.nickname }),
      out: t('left_someone_end', { nickname: props.message.nickname }),
    }[props.message.inout] ?? ''
  );
});
</script>

<style scoped lang="scss"></style>
